import React from 'react'

import ReactWhatsapp from "react-whatsapp";


import diwali from "../images/DIWALI UPDATE 11.jpg";
import diwali2025 from "../images/DIWALI UPDATE  ORDER.jpg";
import kalipujo from "../images/DIWALI SLIDER 4.jpg";
import diwalidress_womens from "../images/DIWALI SLIDER 6.jpg";


import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'






function Diwali() {
    return (
        <div>

          
            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={diwali} className="card-img-top" alt="diwali"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">New Saree Collection </h5>
                                                <p className="card-text">2025 Diwali New Collection</p>
                                             

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                 
                                                    <ReactWhatsapp number="++91 9932517802" className="whatsbutton" message="I would like to express my interest in this product"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={diwali2025} className="card-img-top" alt="diwali2025"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">New Saree Collection  </h5>
                                                <p className="card-text">2025 Diwali New Collection

</p>
                                              
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <ReactWhatsapp number="++91 9932517802" className="whatsbutton" message="I would like to express my interest in this product"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={kalipujo} className="card-img-top" alt="kalipujo"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Smart Look Dresses</h5>
                                                <p className="card-text">2025 Diwali New Collection

</p>
                                          
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <ReactWhatsapp number="++91 9932517802" className="whatsbutton" message="I would like to express my interest in this product"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={diwalidress_womens} className="card-img-top" alt="diwalidress_womens"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Trending Dresses                             </h5>
                                                <p className="card-text">2025 Diwali New Collection

</p>
                                              
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <ReactWhatsapp number="++91 9932517802" className="whatsbutton" message="I would like to express my interest in this product"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
 
            <br />
        </div>
    )
}

export default Diwali